"use client";

import {
  Badge,
  Box,
  Button,
  Container,
  Heading,
  HStack,
  Stack,
  Text,
  VStack,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { useCustomTheme } from "../../contexts/CustomThemeContext";
import MetaReviewDemoPanel from "./MetaReviewDemoPanel";

const MetaReviewDashboard = () => {
  const navigate = useNavigate();
  const { theme } = useCustomTheme();

  const isDark = theme?.name === "dark";

  const pageBg = theme.gradients?.pageBg || theme.background;
  const cardBg = isDark
    ? "linear-gradient(135deg, rgba(17,24,39,0.96), rgba(2,6,23,0.88))"
    : "linear-gradient(to-br, rgba(255,255,255,0.98), rgba(248,250,255,0.94))";

  const borderColor = isDark ? "rgba(255,255,255,0.14)" : "rgba(15,23,42,0.08)";

  const mutedText = isDark ? "rgba(255,255,255,0.68)" : "rgba(15,23,42,0.62)";

  return (
    <Box minH="100vh" bg={pageBg} color={theme.text}>
      <Container maxW="7xl" py={{ base: 5, md: 8 }} px={{ base: 4, md: 6 }}>
        <VStack align="stretch" spacing={6}>
          <Box
            p={{ base: 5, md: 7 }}
            borderWidth="1px"
            borderColor={borderColor}
            borderRadius="24px"
            bg={cardBg}
            boxShadow={theme.shadowMd}
          >
            <Stack spacing={5}>
              <HStack
                justify="space-between"
                align="start"
                flexWrap="wrap"
                gap={3}
              >
                <Stack spacing={2}>
                  <Badge alignSelf="flex-start" colorScheme="purple">
                    Meta App Review Dashboard
                  </Badge>

                  <Heading size={{ base: "md", md: "lg" }}>
                    PickDengu Permission Review Demo
                  </Heading>

                  <Text fontSize="sm" color={mutedText} maxW="3xl">
                    This review-only dashboard demonstrates the exact
                    permissions requested in Meta App Review: WhatsApp Business
                    Management, WhatsApp Business Messaging, and Catalog
                    Management.
                  </Text>
                </Stack>

                <HStack spacing={3}>
                  <Button
                    variant="outline"
                    borderRadius="12px"
                    onClick={() => navigate("/meta-review")}
                  >
                    Back to Review Login
                  </Button>

                  <Button
                    colorScheme="blue"
                    borderRadius="12px"
                    onClick={() => navigate("/meta-review/callback")}
                  >
                    View Callback Page
                  </Button>
                </HStack>
              </HStack>

              <Box
                p={4}
                borderWidth="1px"
                borderColor={borderColor}
                borderRadius="18px"
                bg={isDark ? "rgba(15,23,42,0.56)" : "rgba(239,246,255,0.92)"}
              >
                <Stack spacing={2}>
                  <Heading size="sm">Screencast instructions</Heading>

                  <Text fontSize="sm" color={mutedText}>
                    Start from /meta-review, click Start Meta Permission Grant,
                    complete the Meta/Facebook consent flow, return to
                    /meta-review/callback, sign in with the reviewer account,
                    and land here to test each permission below.
                  </Text>
                </Stack>
              </Box>
            </Stack>
          </Box>

          <MetaReviewDemoPanel />
        </VStack>
      </Container>
    </Box>
  );
};

export default MetaReviewDashboard;
